import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var RequestInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var request_id, include, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          request_id = _ref.request_id, include = _ref.include;
          params = {
            request_id: request_id,
            include: include
          };
          _context.n = 1;
          return erpFetcher().get('sell-trade/get-request-info', {
            params: params
          });
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function RequestInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default RequestInfo;